/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the Http request was cancelled
 * @export
 * @class HttpCancelled
 * @extends {Error}
 */
export class HttpCancelled extends Error {
  /**
   * Creates an instance of HttpCancelled
   * @param {string} message The Error `message`
   * @memberof HttpCancelled
   */
  constructor(message) {
    super(message);
    this.name = `HttpCancelled`;
  }
}

/**
 * Called when the Http request was cancelled
 * @param {string} message The message text
 * @returns {never} never
 */
const throwHttpCancelled = (message) => {
  throw new HttpCancelled(stripIndent(`Http request was cancelled. Reason:`, message));
};

export default throwHttpCancelled;
